var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('NuxtChild',{attrs:{"keep-alive":"","keep-alive-props":{
    include: ['CommunityPage'],
    max: 3
  }}})}
var staticRenderFns = []

export { render, staticRenderFns }